export enum PaymentProcessorName {
  RAZORPAY = "RAZORPAY",
  FREE = "FREE",
  PAYPAL = "PAYPAL",
  PHONEPE = "PHONEPE",
}

export interface CheckoutResponse {
  name: PaymentProcessorName;
}
